import type { CalendarProductId } from '../types/calendarProject';

export type PrintOrientation = 'portrait' | 'landscape';

export interface PrintGeometry {
  productId: CalendarProductId;
  formatLabel: string;
  pageWidthMm: number;
  pageHeightMm: number;
  bleedMm: number;
  safeZoneMm: number;
  orientation: PrintOrientation;
  cssAspectRatio: string;
  previewLabel: string;
}

const defaultBleedMm = 3;
const defaultSafeZoneMm = 5;

export function getPrintGeometry(productId: CalendarProductId): PrintGeometry {
  if (productId === 'basic_year_story') {
    return {
      productId,
      formatLabel: 'A3 portrait',
      pageWidthMm: 297,
      pageHeightMm: 420,
      bleedMm: defaultBleedMm,
      safeZoneMm: defaultSafeZoneMm,
      orientation: 'portrait',
      cssAspectRatio: '297 / 420',
      previewLabel: 'Basic Year Story · A3 portrait · spadávka 3 mm · bezpečná zóna 5 mm',
    };
  }

  if (productId === 'family_planner_cz') {
    return {
      productId,
      formatLabel: 'A3 landscape',
      pageWidthMm: 420,
      pageHeightMm: 297,
      bleedMm: defaultBleedMm,
      safeZoneMm: defaultSafeZoneMm,
      orientation: 'landscape',
      cssAspectRatio: '420 / 297',
      previewLabel: 'Family Planner CZ · A3 landscape MVP · spadávka 3 mm · bezpečná zóna 5 mm',
    };
  }

  return {
    productId,
    formatLabel: 'A3 landscape',
    pageWidthMm: 420,
    pageHeightMm: 297,
    bleedMm: defaultBleedMm,
    safeZoneMm: defaultSafeZoneMm,
    orientation: 'landscape',
    cssAspectRatio: '420 / 297',
    previewLabel: 'FineArt Gallery · A3 landscape MVP · spadávka 3 mm · bezpečná zóna 5 mm',
  };
}
